'use strict';

/**
 * Gemeinsame reine Hilfsfunktionen – keine AWS SDK Abhängigkeiten.
 * Wird von claim-helpers.js (v3), claim-helpers-v2.js (v2) und dem Frontend importiert.
 */

function buildSuchbegriffe(sendungsnummer, packstuecknummer, trackingnummer, id_nummer) {
    const values = [sendungsnummer, packstuecknummer, trackingnummer, id_nummer];
    const filtered = values.filter(v => v != null && typeof v === 'string' && v.trim() !== '');
    return [...new Set(filtered)];
}

function buildClaimItem({ kdnr, absender, suchbegriffe, kommentar, staffId, zustelldatum, spedition, empfaenger }) {
    const timestamp = Date.now();
    const now = new Date().toISOString();
    const item = {
        pk: `CLM#${kdnr}`,
        sk: `#${timestamp}#`,
        gsi1pk: 'CLAIM',
        gsi1sk: `#OFFEN#${timestamp}#`,
        claimId: `CLM#${kdnr}#${timestamp}`,
        kdnr,
        status: 'OFFEN',
        absender,
        suchbegriffe,
        nichtGefundenZaehler: 0,
        erstelltAm: now,
        geaendertAm: now,
    };
    if (kommentar) item.kommentar = kommentar;
    if (staffId) item.staffId = staffId;
    if (zustelldatum) item.zustelldatum = zustelldatum;
    if (spedition) item.spedition = spedition;
    if (empfaenger) item.empfaenger = empfaenger;
    return item;
}

function buildUpdateClaimStatusParams(tableName, claimId, neuerStatus, zusatzFelder = {}) {
    const parts = claimId.split('#');
    const pk = `${parts[0]}#${parts[1]}`;
    const timestamp = parts[2];
    const sk = `#${timestamp}#`;
    const now = new Date().toISOString();
    const newGsi1sk = `#${neuerStatus}#${timestamp}#`;

    let updateExpression = 'SET #status = :status, #gsi1sk = :gsi1sk, #geaendertAm = :geaendertAm';
    const expressionAttributeNames = {
        '#status': 'status',
        '#gsi1sk': 'gsi1sk',
        '#geaendertAm': 'geaendertAm',
    };
    const expressionAttributeValues = {
        ':status': neuerStatus,
        ':gsi1sk': newGsi1sk,
        ':geaendertAm': now,
    };

    Object.entries(zusatzFelder).forEach(([key, value]) => {
        updateExpression += `, #${key} = :${key}`;
        expressionAttributeNames[`#${key}`] = key;
        expressionAttributeValues[`:${key}`] = value;
    });

    return {
        TableName: tableName,
        Key: { pk, sk },
        UpdateExpression: updateExpression,
        ExpressionAttributeNames: expressionAttributeNames,
        ExpressionAttributeValues: expressionAttributeValues,
        ReturnValues: 'ALL_NEW',
    };
}

function computeNichtGefundenZaehler(currentZaehler) {
    return (currentZaehler || 0) + 1;
}

function isRejectionAllowed(erstelltAm, nowMs) {
    const now = nowMs !== undefined ? nowMs : Date.now();
    return new Date(erstelltAm).getTime() + 7 * 24 * 60 * 60 * 1000 <= now;
}

function buildCheckinBody(claim, oldShipment, staff, station) {
    return {
        kdnr: claim.kdnr,
        klasse: oldShipment.klasse,
        spedition: oldShipment.spedition,
        absender: oldShipment.absender,
        sid: oldShipment.sendungsnummer,
        staff, station, did: 0, allowDuplicate: true,
    };
}

function isOlderThan7Days(erstelltAm) {
    if (!erstelltAm) return false;
    const diffDays = (new Date() - new Date(erstelltAm)) / (1000 * 60 * 60 * 24);
    return diffDays >= 7;
}

const FILTER_TABS = [
    { label: 'Offene Suchaufträge', value: 'open' },
    { label: 'Alle Suchaufträge', value: 'all' },
    { label: 'Kürzlich bearbeitet', value: 'recent' },
];

function validateClaimForm(formData) {
    if (!formData.absender || !formData.absender.trim()) return 'Absender ist ein Pflichtfeld.';
    if (!formData.sendungsnummer || !formData.sendungsnummer.trim()) return 'Sendungsnummer ist ein Pflichtfeld.';
    return null;
}

module.exports = {
    buildSuchbegriffe,
    buildClaimItem,
    buildUpdateClaimStatusParams,
    computeNichtGefundenZaehler,
    isRejectionAllowed,
    buildCheckinBody,
    isOlderThan7Days,
    FILTER_TABS,
    validateClaimForm,
};
